import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    styled,
    Modal,
    Fade,
    Backdrop,
} from '@mui/material';
import {
    Error as ErrorIcon,
    Refresh as RefreshIcon,
} from '@mui/icons-material';
import { useQuiz } from '../../pages/quiz/hooks';
import { queueAssessmentForEvaluation } from '../../store/quiz/quizBaseApi';
import { ScreenTypes } from '../../store/quiz/quizSlice';
import { ButtonYellow } from '../buttons';
import { useProfile } from '../../pages/profile/hooks';


const ErrorModal = styled(Modal)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const ErrorContent = styled(Box)({
    background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)',
    borderRadius: '20px',
    padding: '2rem',
    maxWidth: '500px',
    width: '90%',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
    border: '2px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%)',
        zIndex: 0,
    },
});

export default function EvaluationErrorModal({ isOpen, onSuccess }) {
    const [retrying, setRetrying] = useState(false);
    const { setEvaluationId, currentCourseDetails, result } = useQuiz();
    const {profile} = useProfile();

    const retryEvaluation = async () => {
        setRetrying(true);
        try {
            const { data } = await queueAssessmentForEvaluation({
                body: {
                    ...currentCourseDetails,
                    assessmentAnswers: result,
                }
            });
            if (onSuccess && "function" === typeof onSuccess) {
                onSuccess();
            }
            setEvaluationId(data.evaluationId);
        } catch (e) {
            console.error("error while posting evaluation", e)
        } finally {
            setRetrying(false);
        }
    }

    return (
        <ErrorModal
            open={isOpen}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={isOpen}>
                <ErrorContent>
                    <ErrorIcon sx={{
                        fontSize: '4rem',
                        color: '#e74c3c',
                        marginBottom: '1rem',
                        filter: 'drop-shadow(0 0 10px rgba(231, 76, 60, 0.5))'
                    }} />
                    <Typography variant="h4" sx={{
                        color: '#fff',
                        marginBottom: '1rem',
                        fontWeight: 'bold',
                        textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}>
                        {profile && profile.firstName ? String(profile.firstName).trim() : 'Hey'}, We Have a Problem!
                    </Typography>
                    <Typography sx={{
                        color: '#fff',
                        opacity: 0.9,
                        marginBottom: '1.5rem'
                    }}>
                        We encountered an issue while evaluating your assessment. Don't worry, your progress is saved! Would you like to try again?
                    </Typography>
                    <Box justifyContent={'center'} display={'flex'}>
                        <Box sx={{ width: '50%' }}>
                            <ButtonYellow
                                buttonProps={{
                                    onClick: () => retryEvaluation(),
                                    style: { fontSize: '1.2rem' },
                                    disabled: retrying
                                }}
                            >
                                {retrying ? 'Retrying...' : 'Retry Evaluation'}
                            </ButtonYellow>
                        </Box>
                    </Box>
                </ErrorContent>
            </Fade>
        </ErrorModal>
    )
}